








import { Component, Prop, Mixins } from 'vue-property-decorator'

import CourseBaseForm from '@/components/forms/course/CourseBaseForm.vue'
import PermissionsMixin from '@/mixins/PermissionsMixin'
import { CourseLargeResource, GroupLargeResource } from '@/store/types'

@Component({
  components: {
    CourseBaseForm,
  },
})
export default class CoursesItemGroupCommon extends Mixins(PermissionsMixin) {
  @Prop({ required: true })
  private course!: CourseLargeResource

  @Prop({ required: true })
  private group!: GroupLargeResource
}
